import React, { useEffect, useState } from "react";
import { func, string } from "prop-types";
import { Badge, Button, CloseButton, ListGroup, Stack } from "react-bootstrap";
import { uploadAttachment } from "@helpers";
import clsx from "clsx";
import { v4 as uuidv4 } from "uuid";

const AttachmentUploader = ({ error, onUploadFinish, initAttachments }) => {
  // state
  const [attachments, setAttachments] = useState([]);

  // variables

  // logics before hooks

  // hooks

  // logics
  const upload = () => {
    uploadAttachment((files) => {
      let newAttachments = [...attachments];
      if (files.length) {
        for (const file of files) {
          const { fileUrl, originalFile } = file;
          const { name, type } = originalFile.file;
          const url =
            type.split("/")[0] === "image" ? originalFile.fileUrl : fileUrl;
          newAttachments.push({ id: uuidv4(), fileUrl: url, name, type });
        }
        setAttachments(newAttachments);
        onUploadFinish(newAttachments);
      }
    });
  };

  const removeAttachment = (fileUrl) => {
    const updatedAttachments = [...attachments].map((each) =>
      each.fileUrl === fileUrl ? { ...each, isDeleted: true } : each
    );

    setAttachments(updatedAttachments);
    onUploadFinish(updatedAttachments);
  };

  // UI partials

  useEffect(() => {
    setAttachments(initAttachments);
  }, [initAttachments]);
  // effects

  // render
  return (
    <div
      className={clsx(
        "d-grid w-100 h-100 border rounded py-3",
        error ? "border-danger" : ""
      )}
    >
      <Stack gap={3} className="align-items-center p-3 m-auto">
        {attachments?.length ? (
          <ListGroup className="w-100 h-100">
            {attachments.map((attachment, index) => {
              if (attachment.isDeleted) return null;
              return (
                <ListGroup.Item key={index} className="border">
                  <div className="d-flex justify-content-between align-items-center">
                    {attachment.name}
                    <CloseButton
                      onClick={() => removeAttachment(attachment.fileUrl)}
                    />
                  </div>
                </ListGroup.Item>
              );
            })}
          </ListGroup>
        ) : (
          <span className="text-muted"></span>
        )}
        <div>
          <Button variant="outline-primary" onClick={upload}>
            {attachments?.length ? "ADD" : "UPLOAD"} ATTACHMENTS
          </Button>
          <div type="invalid" className="text-danger text-center">
            {error}
          </div>
        </div>
        <Stack className="align-items-center" gap={1}>
          <span>Accepted attachment's extension:</span>
          <div>
            <Stack direction="horizontal" gap={1} className="flex-wrap">
              <Badge bg="secondary">.jpg</Badge>
              <Badge bg="secondary">.jpeg</Badge>
              <Badge bg="secondary">.png</Badge>
              <Badge bg="secondary">.docx</Badge>
              <Badge bg="secondary">.xslx</Badge>
              <Badge bg="secondary">.pptx</Badge>
              <Badge bg="secondary">.pdf</Badge>
              <Badge bg="secondary">.zip</Badge>
            </Stack>
          </div>
        </Stack>
      </Stack>
    </div>
  );
};

/* required: display name */
AttachmentUploader.displayName = "AttachmentUploader";

/* required: props types */
AttachmentUploader.propTypes = { error: string, onUploadFinish: func };

/* required: default props */
AttachmentUploader.defaultProps = { error: "", onUploadFinish: () => {} };

export { AttachmentUploader };
